<script>

    import { toast } from 'bulma-toast'
    import { userStore, invoicesStore, notifyStore } from '../stores'

    import FacturamaService from '../$services/facturama.services'

    import Form from '../$components/form.svelte'

    import Select from '../$components/select.svelte'
    import InputText from '../$components/input.text.svelte'

    import ButtonSave from '../$components/button.save.svelte'

    let data = {}
    let loading = false

    async function createInvoice() {

        loading = true
        const resp = await FacturamaService.createInvoice(data, $userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        invoicesStore.append(resp.data)
        toast({message: 'Factura creada', type: 'is-success'})
        notifyStore.set('facturama_invoices_updated')
        data = {}
    }

</script>

<div class="subtitle is-5">Facturar</div>

<Form on:submit={createInvoice} { loading } >

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.amount} label="Monto" placeholder="Monto a facturar" />
        </div>
        <div class="column">
            <Select bind:value={ data.cfdiUse } 
                label="Uso del CFDI"
                options={[
                    {value: 'P01', text: 'Por definir'},
                    {value: 'G03', text: 'Gastos en general'},
                ]}
            />
        </div>
    </div>

    <Select bind:value={ data.paymentType } 
        label="Método de pago"
        options={[
            {value: '99', text: 'Por definir'},
            {value: '04', text: 'Tarjeta de crédito'},
            {value: '28', text: 'Tarjeta de débito'},
            {value: '01', text: 'Efectivo'},
            {value: '02', text: 'Cheque nominativo'},
            {value: '03', text: 'Transferencia electrónica de fondos'}
        ]}
    />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonSave icon="file-invoice-dollar" text="Generar" {loading} />
    </div>

</Form>